import　React from 'react';
import './Contact.css';
import SocialMediaBar from "../../components/SocialMediaBar/SocialMediaBar";

const Contact = () =>
    <div id="Contact" className={"Contact"}>
        <SocialMediaBar/>
    </div>

export default Contact;